import { FormattedMessage } from 'react-intl';

type LoginFooterProps = {
    buildNumber: string;
};

export const LoginFooter = (props: LoginFooterProps) => {

    const { buildNumber } = props;

    return (
        <div className="login-page-footer position-fixed bottom-0 start-0 end-0 d-flex justify-content-between align-items-center">
            <span>

                <FormattedMessage defaultMessage="GMetrix SMS" id="gmetrix_sms.6e928a84" />
                {buildNumber ? ` v${buildNumber}` : ''}
            </span>
            <span>
                &copy;
                {' '}
                {new Date().getFullYear()}
                {' '}

                <FormattedMessage defaultMessage="GMetrix LLC." id="gmetrix_llc.ed3a74a0" />
                {' '}
                {<FormattedMessage defaultMessage="All Rights Reserved" description="footer" id="all_rights_reserved.2ca335b8" /> || 'All Rights Reserved'}
            </span>
            <span>
                <a href="http://gmetrix.com/Home/PrivacyPolicyEducation" rel="noopener noreferrer" target="_blank">
                    {<FormattedMessage defaultMessage="Privacy Policy" id="privacy_policy.4dfb380c" /> || 'Privacy Policy'}
                </a>
                {' | '}
                <a href="https://support.gmetrix.net/support/home" rel="noopener noreferrer" target="_blank">
                    {<FormattedMessage defaultMessage="Help/Support" id="helpsupport.9afbcc7b" /> || 'Help/Support'}
                </a>
            </span>
        </div>
    );

};
